
import React from 'react';
import { Bookmark, BookmarkCategory, ArchiveFile } from '../types';
import WikiHeader from './WikiHeader';

interface ProfileCollectionProps {
  bookmarks: Bookmark[];
  categories: BookmarkCategory[];
  onCategorySelect: (category: string) => void;
  onBack: () => void;
  onMenuClick: () => void;
  isSidebarOpen: boolean;
}

const ProfileCollection: React.FC<ProfileCollectionProps> = ({ 
  bookmarks, 
  categories, 
  onCategorySelect, 
  onBack, 
  onMenuClick, 
  isSidebarOpen 
}) => {
  // Only root categories or those with bookmarks but no shown parent
  const rootCategories = categories.filter(c => !c.parentId);
  
  return (
    <div className="flex flex-col h-full bg-[#fbfaf6] dark:bg-stone-900 transition-colors duration-300">
      <div className="flex-1 overflow-y-auto custom-scrollbar p-6 lg:p-10">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {rootCategories.map(cat => {
              const count = bookmarks.filter(b => b.categoryPath.startsWith(cat.path)).length;
              return (
                <button
                  key={cat.id}
                  onClick={() => onCategorySelect(cat.path)}
                  className="bg-white dark:bg-stone-800 p-6 rounded-2xl shadow-sm border border-stone-200 dark:border-stone-700 hover:border-amber-500 transition-all text-left flex items-start gap-4 group"
                >
                  <div className="w-12 h-12 rounded-xl bg-amber-50 dark:bg-amber-900/20 flex items-center justify-center text-amber-500 group-hover:bg-amber-500 group-hover:text-white transition-colors">
                    <i className="fa-solid fa-folder text-xl"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-stone-800 dark:text-stone-100 group-hover:text-amber-600 transition-colors uppercase tracking-tight text-sm">{cat.name}</h3>
                    <p className="text-xs text-stone-500 mt-1">{count} items</p>
                  </div>
                </button>
              );
            })}
            
            {rootCategories.length === 0 && (
              <div className="col-span-full py-20 text-center bg-white dark:bg-stone-800 rounded-2xl border-2 border-dashed border-stone-100 dark:border-stone-800">
                <i className="fa-solid fa-folder-open text-stone-200 dark:text-stone-700 text-6xl mb-4"></i>
                <h4 className="font-bold text-stone-800 dark:text-stone-200 uppercase tracking-widest">No Folders Created</h4>
                <p className="text-sm text-stone-400 mt-2">Start bookmarking entries to build your collection.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileCollection;
